import api from './api';

function mapClaim(raw = {}) {
  return {
    id: raw.id ?? raw.Id ?? '',
    usuarioId: raw.usuarioId ?? raw.UsuarioId ?? '',
    horasSolicitadas: Number(raw.horasSolicitadas ?? raw.HorasSolicitadas ?? 0),
    comentario: raw.comentario ?? raw.Comentario ?? '',
    comentarioResolucion:
      raw.comentarioResolucion ??
      raw.ComentarioResolucion ??
      raw.comentarioOpcional ??
      raw.ComentarioOpcional ??
      '',
    estado: raw.estado ?? raw.Estado ?? 'Pendiente',
    aprobadoPor: raw.aprobadoPor ?? raw.AprobadoPor ?? null,
    fechaSolicitud: raw.fechaSolicitud ?? raw.FechaSolicitud ?? raw.createdAt ?? raw.CreatedAt ?? null,
    fechaResolucion: raw.fechaResolucion ?? raw.FechaResolucion ?? null,
    createdAt: raw.createdAt ?? raw.CreatedAt ?? null,
    updatedAt: raw.updatedAt ?? raw.UpdatedAt ?? null,
    usuario: raw.usuario ?? raw.Usuario ?? null,
  };
}

const ClaimedHoursService = {
  createClaim: async (data) => {
    const response = await api.post('/horas-reclamadas', data);
    return mapClaim(response.data);
  },

  getMyClaims: async (usuarioId) => {
    const params = usuarioId ? { usuarioId } : undefined;
    const response = await api.get('/horas-reclamadas/me', { params });
    return Array.isArray(response.data) ? response.data.map(mapClaim) : [];
  },

  getPendingClaims: async () => {
    const response = await api.get('/horas-reclamadas/pending');
    return Array.isArray(response.data) ? response.data.map(mapClaim) : [];
  },

  approveClaim: async (id, data) => {
    await api.post(`/horas-reclamadas/${id}/approve`, data);
  },

  rejectClaim: async (id, data) => {
    await api.post(`/horas-reclamadas/${id}/reject`, data);
  },

  getAvailableClaimHours: async (usuarioId) => {
    const params = usuarioId ? { usuarioId } : undefined;
    const response = await api.get('/horas-reclamadas/me/disponibles', { params });
    return {
      usuarioId: response.data?.usuarioId ?? response.data?.UsuarioId ?? '',
      horasDisponibles: Number(response.data?.horasDisponibles ?? response.data?.HorasDisponibles ?? 0),
    };
  },
};

export default ClaimedHoursService;
